export const normalizePortalLanguage = (value) => {
  const normalized = String(value || '').trim().toLowerCase().replace('_', '-');
  if (normalized.startsWith('zh') || normalized === 'chinese') return 'zh';
  if (normalized.startsWith('en') || normalized === 'english') return 'en';
  return null;
};

export const resolveInitialPortalLanguage = ({ search = '', stored = null } = {}) => {
  const params = new URLSearchParams(search || '');
  const hostLanguage = normalizePortalLanguage(params.get('locale') || params.get('lang'));
  return hostLanguage || normalizePortalLanguage(stored) || 'en';
};

export const getNextPortalLanguage = (current) => (
  normalizePortalLanguage(current) === 'zh' ? 'en' : 'zh'
);
